// extracted by mini-css-extract-plugin
export default {"titleBox":"ZXPVPkLuXPPgyqSDcGFA","printBtn":"FWhlIF5FzaquDvFkaYQ0"};